import { SidebarTrigger } from '@/components/shadcn/sidebar'
import { Separator } from '@/components/shadcn/separator'
import { LanguageSwitcher } from '@/components/LanguageSwitcher'
import { AppBreadcrumb } from '../AppBreadcrumb'
import { CompanySwitcher } from './components/CompanySwitcher'
import { NotificationsButton } from './components/NotificationsButton'
import { ThemeToggle } from './components/ThemeToggle'
import { HelpPopover } from './components/HelpPopover'

export function AppHeader() {
  return (
    <header className="flex h-14 shrink-0 items-center gap-3 border-b border-border px-4 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <SidebarTrigger />
      <Separator orientation="vertical" className="h-4" />
      <AppBreadcrumb />

      <div className="ml-auto flex items-center gap-4 mr-3">
        {/* Not available yet */}
        {/* <QuickActions /> */}
        <CompanySwitcher />
        <NotificationsButton />
        <ThemeToggle />
        <LanguageSwitcher />
        <HelpPopover />
      </div>
    </header>
  )
}
